import * as React from 'react'
import { useMediaQuery } from 'react-responsive'

import { sp } from '@/style'

export const isPc = () => useMediaQuery({ minWidth: sp + 1 })
export const isSp = () => useMediaQuery({ maxWidth: sp })

interface Props {
  pc?: React.ReactNode
  sp?: React.ReactNode
}

export const Responsive: React.VFC<Props> = ({ pc, sp }) => {
  const matchPc = isPc()
  const matchSp = isSp()
  if (matchPc) {
    return <>{pc}</>
  }

  if (matchSp) {
    return <>{sp}</>
  }

  return <>{pc}</>
}
